export default __webpack_public_path__ + "static/media/Girdle of the Oxmal.9d933912.jpg";